module.exports = __webpack_public_path__ + "kazan.e44872f0790c1d0d949b982755b3f2c4.jpg";